import * as React from 'react';


export const LicenceInfo = () => (
    <a href="https://opensource.org/licenses/MIT" rel="nofollow">
        <img src="https://camo.githubusercontent.com/3ccf4c50a1576b0dd30b286717451fa56b783512/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4c6963656e73652d4d49542d79656c6c6f772e737667" alt="License: MIT" data-canonical-src="https://img.shields.io/badge/License-MIT-yellow.svg"/>
    </a>
);


// WEBPACK FOOTER //
// ./src/home/components/LicenceInfo.tsx